import { Link } from 'react-router-dom';

const ButtonLink = ({ color, children, ...props }) => (
  <Link className="button-link text-color-white" {...props}>
      <div className={`button-link-box bg-color-${color}`}>
        {children}
      </div>
    </Link>
);

export default ButtonLink;
